import type { ReactNode } from 'react'
import React from 'react'

import DrawerContextProvider from '@app/src/components/Drawer/DrawerContextProvider'
import SentryContextProvider from '@app/src/components/SentryContextProvider'
import AccessibleOrganizationsContextProvider from '@app/src/context/AccessibleOrganizationsContextProvider'
import AccountContextProvider from '@app/src/context/AccountContextProvider'
import AiJobsContextProvider from '@app/src/context/AiJobsContextProvider'
import AmplitudeContextProvider from '@app/src/context/AmplitudeContextProvider'
import AuthenticationContextProvider from '@app/src/context/AuthenticationContextProvider'
import RiskSettingsContextProvider from '@app/src/context/RiskSettingsContextProvider'
import { SessionNavigationProvider } from '@app/src/context/SessionNavigationContext'
import SignalRContextProvider from '@app/src/context/SignalRContextProvider'
import SnackbarProvider from '@app/src/context/SnackbarContextProvider'
import { ConfirmProvider } from 'material-ui-confirm'
import { useIntl } from 'react-intl'
import ProvidersModals from './components/ProvidersModals'
import ProvidersModalContextProvider from './context/ProvidersModalContextProvider'

type ApplicationContextsProps = {
  children: ReactNode
}

const ApplicationContexts: React.FC<ApplicationContextsProps> = ({ children }: ApplicationContextsProps) => {
  const { formatMessage } = useIntl()
  return (
    <SnackbarProvider>
      <AuthenticationContextProvider>
        <SignalRContextProvider>
          <AccountContextProvider>
            <SessionNavigationProvider>
              <SentryContextProvider>
                <AccessibleOrganizationsContextProvider>
                  <AmplitudeContextProvider>
                    <RiskSettingsContextProvider>
                      <AiJobsContextProvider>
                        <ProvidersModalContextProvider>
                          <ConfirmProvider
                            defaultOptions={{
                              title: formatMessage({ id: 'general.areYouSure' }),
                              cancellationButtonProps: { variant: 'outlined' },
                              confirmationButtonProps: { variant: 'contained' },
                              cancellationText: formatMessage({ id: 'general.cancel' }),
                              confirmationText: formatMessage({ id: 'general.confirm' }),
                            }}
                          >
                            <DrawerContextProvider>
                              {children}
                              <ProvidersModals />
                            </DrawerContextProvider>
                          </ConfirmProvider>
                        </ProvidersModalContextProvider>
                      </AiJobsContextProvider>
                    </RiskSettingsContextProvider>
                  </AmplitudeContextProvider>
                </AccessibleOrganizationsContextProvider>
              </SentryContextProvider>
            </SessionNavigationProvider>
          </AccountContextProvider>
        </SignalRContextProvider>
      </AuthenticationContextProvider>
    </SnackbarProvider>
  )
}

export default ApplicationContexts
